import * as types from 'actions/actionTypes';
import initialState from './initialState';

/**
 * reducer per gestire le interrogazioni a entityservices - device
 * @param {*} state
 * @param {*} action
 */
export default function deviceSearchReducer(state = initialState.deviceSearch, action){

    switch(action.type)
    {
        case types.GET_DEVICE_REQUEST:
            return {...state, item: null, error: null, isSearching: true};
        case types.GET_DEVICE_SUCCESS:
            var device;
            if( action.data &&  action.data.device )
            {
                device = action.data.device;
            }
            return {...state, item: device, error: null, isSearching: false};
        case types.GET_DEVICE_ERROR:
            return {...state, error: action.data, isSearching: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/deviceSearchReducer.js